module.exports = __webpack_public_path__ + "static/media/flag.56790e95.png";